import AnimatedLottieView from 'lottie-react-native';
import { Platform, View } from 'react-native';

const carouselData = [
  {
    title: 'Create a new project...',
    caption: 'Just fill out a few details and get going',
    image: Platform.OS === 'web' ? <View style={{ height: 100, width: 100, top: -10, flex: 1, backgroundColor: 'transparent' }} /> : <AnimatedLottieView source={require('@assets/animations/76113-chart-reports.json')} style={{ height: 100, width: 100, top: -10, flex: 1 }} loop autoPlay />

  },
  {
    title: '...Customise to your liking',
    caption: 'Add work packages and tasks, and we will handle the charts and graphs',
    image: Platform.OS === 'web' ? <View style={{ height: 100, width: 100, flex: 1, backgroundColor: 'transparent' }} /> : < AnimatedLottieView source={require('@assets/animations/chart_animation.json')} style={{ height: 100, width: 100, flex: 1 }} loop autoPlay />
  },
  {
    title: "And don't forget to share",
    caption: 'Easily share your data with other users and get those projects going',
    image: Platform.OS === 'web' ? <View style={{ height: 100, width: 100, flex: 1, backgroundColor: 'transparent' }} /> : < AnimatedLottieView source={require('@assets/animations/share_animation.json')} style={{ height: 100, width: 100, flex: 1 }} loop autoPlay />
  }
];

const dataCarouselData = [
  {
    title: 'Your Data is Safe',
    caption: 'Just fill out a few details and get going',
    image: Platform.OS === 'web' ? <View style={{ height: 100, width: 100, flex: 1, backgroundColor: 'transparent' }} /> : < AnimatedLottieView source={require('@assets/animations/lockAnimation.json')} style={{ height: 100, width: 100, flex: 1 }} loop autoPlay />
  },
  {
    title: 'Easily make new models',
    caption: 'Make models and share them with other users, or keep them private for your own use',
    image: Platform.OS === 'web' ? <View style={{ height: 100, width: 100, flex: 1, backgroundColor: 'transparent' }} /> : < AnimatedLottieView source={require('@assets/animations/41291-human-resources-approval-animation.json')} style={{ height: 100, width: 100, flex: 1 }} loop autoPlay />
  },
  {
    title: "And don't forget me!",
    caption: 'Your AI helper is always here to help you out with your data and models',
    image: Platform.OS === 'web' ? <View style={{ height: 100, width: 100, flex: 1, backgroundColor: 'transparent' }} /> : < AnimatedLottieView source={require('@assets/animations/automation_robot.json')} style={{ height: 100, width: 100, flex: 1 }} loop autoPlay />
  },
]

const knowledgeBaseCarouselData = [
  {
    title: 'Internal Knowledge Base',
    caption: 'Access detailed guides and documentation to streamline your workflow',
    image: Platform.OS === 'web' ? <View style={{ height: 100, width: 100, flex: 1, backgroundColor: 'transparent' }} /> : <AnimatedLottieView source={require('@assets/animations/flow.json')} style={{ height: 100, width: 100, flex: 1 }} loop autoPlay />
  },
  {
    title: 'External Knowledge Base',
    caption: 'Share insights and articles with the community to foster collaboration',
    image: Platform.OS === 'web' ? <View style={{ height: 100, width: 100, flex: 1, backgroundColor: 'transparent' }} /> : <AnimatedLottieView source={require('@assets/animations/wired-flat-27-globe.json')} style={{ height: 100, width: 100, flex: 1 }} loop autoPlay />
  },
  {
    title: 'Stay Updated',
    caption: 'Keep up with the latest trends and updates in your field',
    image: Platform.OS === 'web' ? <View style={{ height: 100, width: 100, flex: 1, backgroundColor: 'transparent' }} /> : <AnimatedLottieView source={require('@assets/animations/127379-create-post.json')} style={{ height: 100, width: 100, flex: 1 }} loop autoPlay />
  }
]

export { carouselData, dataCarouselData, knowledgeBaseCarouselData };